import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './app/App';
import './styles/theme.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found — index.html is missing #root.');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
